import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import EnTranslations from './translations/en';
import { logError } from '~/errors/logger';
import { Translator } from './translation.types';

i18n.use(initReactI18next).init({
  lng: 'en',
  resources: {
    en: {
      translation: EnTranslations,
    },
  },
  missingKeyHandler: (_lngs, _ns, key) => {
    logError(`Missing translation key: ${key}`);
  },
  interpolation: {
    escapeValue: false,
  },
  missingInterpolationHandler: (key) => {
    logError(`Missing translation param: ${key}`);
  },
});

export const translate = i18n.t.bind(i18n) as Translator;

export default i18n;
